import React from 'react';

import { INTEGRATION_FLAGS, PROVIDERS_INTEGRATION_FLAGS } from '../../constants';
import FiltersSelectContent from '../FiltersSelectContent';

interface FilterIntegrationFlagsPorps {
  isProviderResource: boolean;
  type?: string;
}

const FilterIntegrationFlags: React.FC<FilterIntegrationFlagsPorps> = ({
  type = 'integrationFlags',
  isProviderResource,
}) => <FiltersSelectContent type={type} items={isProviderResource ? PROVIDERS_INTEGRATION_FLAGS : INTEGRATION_FLAGS} />;
export default FilterIntegrationFlags;
